import React, { useRef, useState } from "react";

export default function UploadWizard({ onUploadStart, error, compact }) {
  const inputRef = useRef();
  const [dragging, setDragging] = useState(false);
  const [selectedFile, setSelectedFile] = useState(null);

  function handleFile(file) { if (file) setSelectedFile(file); }
  function handleDrop(e) { e.preventDefault(); setDragging(false); handleFile(e.dataTransfer.files[0]); }
  function handleChange(e) { handleFile(e.target.files[0]); }
  function handleAnalyze() {
    if (!selectedFile) return;
    const f = selectedFile;
    setSelectedFile(null);
    onUploadStart(f);
  }

  const ext = selectedFile?.name.split(".").pop().toLowerCase();
  const isImage = ["png", "jpg", "jpeg"].includes(ext);
  const isPDF = ext === "pdf";

  return (
    <div style={s.page}>
      <div style={{ ...s.card, maxWidth: "100%", boxShadow: "none", padding: 0, borderRadius: 0 }}>

        {/* Header */}
        <div style={s.header}>
          <span style={s.headerIcon}>📂</span>
          <div>
            <div style={s.headerTitle}>Upload Data File</div>
            <div style={s.headerSub}>CSV · Excel · Image · PDF</div>
          </div>
        </div>

        {/* Drop zone */}
        <div
          style={{
            ...s.dropzone,
            borderColor: dragging ? "#1a56db" : selectedFile ? "#057a55" : "#cbd5e1",
            background: dragging ? "#eff6ff" : selectedFile ? "#f0fdf4" : "#f8fafc",
          }}
          onDragOver={e => { e.preventDefault(); setDragging(true); }}
          onDragLeave={() => setDragging(false)}
          onDrop={handleDrop}
          onClick={() => inputRef.current.click()}
        >
          <input ref={inputRef} type="file"
            accept=".csv,.xlsx,.xls,.png,.jpg,.jpeg,.pdf"
            style={{ display: "none" }} onChange={handleChange} />

          {selectedFile ? (
            <div style={s.fileSelected}>
              <span style={{ fontSize: 34 }}>{isPDF ? "📑" : isImage ? "🖼️" : "📊"}</span>
              <div style={{ flex: 1 }}>
                <div style={s.fileName}>{selectedFile.name}</div>
                <div style={s.fileMeta}>
                  {(selectedFile.size / 1024).toFixed(1)} KB
                  {(isImage || isPDF) && <span style={s.ocrTag}> · OCR will be applied</span>}
                </div>
              </div>
              <button style={s.clearBtn}
                onClick={e => { e.stopPropagation(); setSelectedFile(null); }}>✕ Change</button>
            </div>
          ) : (
            <div style={s.dropContent}>
              <div style={{ fontSize: 36, marginBottom: 6 }}>⬆️</div>
              <div style={s.dropText}>Drag & drop or <span style={s.dropLink}>click to browse</span></div>
              <div style={s.dropHint}>CSV, Excel, PNG, JPG, PDF</div>
            </div>
          )}
        </div>

        {error && <div style={s.error}>⚠️ {error}</div>}

        {/* Analyze button */}
        <button
          style={{ ...s.analyzeBtn, opacity: selectedFile ? 1 : 0.45, cursor: selectedFile ? "pointer" : "not-allowed" }}
          onClick={handleAnalyze}
          disabled={!selectedFile}
        >
          ⚡ Analyze with AI Pipeline
        </button>

      </div>
    </div>
  );
}

const s = {
  page: { width: "100%" },
  card: {
    background: "#fff", width: "100%",
    display: "flex", flexDirection: "column", gap: 18,
  },
  header: { display: "flex", alignItems: "center", gap: 12 },
  headerIcon: { fontSize: 30 },
  headerTitle: { fontSize: 20, fontWeight: 700, color: "#111827" },
  headerSub: { fontSize: 12, color: "#9ca3af", marginTop: 2 },
  dropzone: {
    border: "2px dashed", borderRadius: 12, padding: "24px 16px",
    textAlign: "center", cursor: "pointer", transition: "all 0.2s",
  },
  dropContent: { display: "flex", flexDirection: "column", alignItems: "center" },
  dropText: { fontSize: 14, color: "#374151" },
  dropLink: { color: "#1a56db", fontWeight: 600 },
  dropHint: { fontSize: 12, color: "#9ca3af", marginTop: 4 },
  fileSelected: { display: "flex", alignItems: "center", gap: 12, textAlign: "left" },
  fileName: { fontWeight: 600, fontSize: 14, color: "#111827", wordBreak: "break-all" },
  fileMeta: { fontSize: 12, color: "#6b7280", marginTop: 2 },
  ocrTag: { color: "#7c3aed", fontWeight: 700 },
  clearBtn: {
    background: "none", border: "1px solid #e5e7eb", borderRadius: 6,
    padding: "3px 10px", cursor: "pointer", color: "#9ca3af", fontSize: 12, flexShrink: 0,
  },
  error: {
    background: "#fef2f2", border: "1px solid #fca5a5",
    borderRadius: 8, padding: "10px 14px", color: "#991b1b", fontSize: 13,
  },
  analyzeBtn: {
    width: "100%", padding: "14px", fontSize: 16, fontWeight: 700,
    background: "linear-gradient(135deg, #1a56db, #1e40af)",
    color: "#fff", border: "none", borderRadius: 12,
    boxShadow: "0 4px 16px rgba(26,86,219,0.4)", letterSpacing: 0.4,
  },
};
